import { render, staticRenderFns } from "./PatientDirectory.vue?vue&type=template&id=0cd663ab&scoped=true&"
import script from "./PatientDirectory.vue?vue&type=script&lang=js&"
export * from "./PatientDirectory.vue?vue&type=script&lang=js&"
import style0 from "./PatientDirectory.vue?vue&type=style&index=0&id=0cd663ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd663ab",
  null
  
)

export default component.exports